// src/db/neoConectaDB.js
import { onUpgradeNeeded } from "./schema";

const DB_NAME = "NeoConectaDB";
const DB_VERSION = 1;

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      try {
        onUpgradeNeeded(event);
      } catch (err) {
        console.error("Error en onupgradeneeded:", err);
        // si tiras error aquí, aborta la versión
      }
    };

    request.onsuccess = () => {
      const db = request.result;

      db.onversionchange = () => {
        console.warn("Nueva versión de la DB, cerrando conexión");
        db.close();
      };

      resolve(db);
    };

    request.onerror = (event) => {
      console.error("DB Error:", event);
      reject(event.target.error);
    };

    request.onblocked = () => {
      console.warn("DB bloqueada, cierra otras pestañas del sitio.");
    };
  });
}

// (opcional) para dev: borrar todo
export function deleteDB() {
  return new Promise((resolve) => {
    const req = indexedDB.deleteDatabase(DB_NAME);

    req.onsuccess = () => {
      console.log("NeoConectaDB eliminada.");
      resolve(true);
    };
    req.onerror = () => {
      console.warn("No se pudo eliminar NeoConectaDB (quizá no existe).");
      resolve(false);
    };
    req.onblocked = () => {
      console.warn("NeoConectaDB bloqueada, cierra otras pestañas.");
    };
  });
}
